import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DEFAULT_PAGING, DEFAULT_SNACKBAR_CONFIG, Logger, MediaPreviewComponent, OrganizationService, PreviewMode, UtilityService } from 'src/app/@shared';
import { EventService, Offer, Event, OfferDomain, OfferPromo, OfferPromoService, PromoDomain, CloneOfferComponent, LabelType, MontageBuilderService, OfferVariantListModel, SettingsService, OfferProductService, Product, OfferDetailService, AssetDetails, MontageHistoryDialogComponent, AssetsListService, MontageHistoryPreviewComponent } from '../..';
import { getUrlParams, shouldShowPreEditMontageHistory } from '../../components/new-montage-editor/models/montage.model';
import { OfferService } from 'src/app/modules/standard/v1';
import { combineLatest, distinctUntilChanged, filter, firstValueFrom, map, Observable, of, Subject, Subscription, take, takeUntil, tap } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AuthorizeControlService, CommentsComponent } from 'pr1-ui-components';
import { Status } from '../../models/offer-promo-status';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventWorkflowService } from '../../services/event-workflow.service';
import { WorkflowStage } from '../../models/workflow-stage.model';
import { isPropertyModifiedInList, getPreviousStepOldValue as lookupPreviousStepOldValue, getActivityLogPropertyName, getActivityLogOldValue } from '../../utilities/previous-step-changes.util';
const log = new Logger('OfferComponent');

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent<TOfferDomain extends OfferDomain<Offer>, TOfferPromo extends OfferPromo, TEvent extends Event, TPromoDomain extends PromoDomain<OfferPromo>, T extends Product> implements OnInit, OnDestroy {
  offer$ = this.offerDetailService.offer$.pipe(
    distinctUntilChanged(),
    tap((offer: any) => {
      this.showJunctionAi = false;
      if (offer) {
        this.updatePricingPreviewHtml(offer);
        this.updateImage(offer);
        if (JSON.stringify(this.offerResponse) != JSON.stringify(offer)) {
          this.offerResponse = offer;
          this.showJunctionAi = offer.OfferHasProducts;
          this.montageBuilderService.creativeId = offer.JAICreativeMontageId;
          if (this.canEdit() && offer.JAICreativeId) {
            if (this.jaiCreativeInfo != offer.JAICreativeId) {
              this.jaiCreativeInfo = offer.JAICreativeId;
              this.searchCount = 0;
              this.showReRun = false;
              this.getJAICreative(offer.JAICreativeId);
            }
          } else {
            this.jaiCreativeInfo = '';
            this.searchCount = 0;
            this.previewInfo = "";
            this.showReRun = false;
            this.offerpromoService.jaiCreativeInfo(null);
          }
        }
      }
    })
  );
  roles = {
    reviewer: 0,
    approver: 1,
    editor: 2,
  };
  offerId: string = '0';
  versionNames: string[] = [];
  variantsList: any[] = [];
  baseVariantId: string = '';
  public labelType: number = 0;
  newVersionName = new FormControl<any>(null);
  VersionCtrl = new FormControl<string>('');
  applyChanges = new FormControl<boolean>(false);
  offerTypeIdsByEventList: (OfferVariantListModel | null)[] = [];
  currentTypeIndex: number = -1;
  subscriptions: Subscription = new Subscription();
  eventListPageDetails: any;
  public offerlistModelSub: any = null;
  public disableNewVersion: boolean = false;
  public variantsCount: number = 0;
  public activeNavItem: string = '';
  public LabelType = LabelType;
  public showReRun: boolean = false;
  pricingPreviewHtml: string = '';
  viewModel$ = combineLatest([
    this.eventService.getEvent(this.route.snapshot.params['eventId']),
    this.montageBuilderService.montageBuilderStatus$,
    this.montageBuilderService.useNewMontageEditor$,
    this.montageBuilderService.montageBuilderCheckConfigure$,
    this.offerpromoService.workflowStages$,
    this.offerpromoService.offerDetailsValidState$
  ]).pipe(
    map(([event, montageBuilderStatus, useNewMontageEditor, montageBuilderCheckConfigure, workflowStages, offerValidState]) => {
      this.workflowStages = workflowStages;
      return { event, montageBuilderStatus, useNewMontageEditor, montageBuilderCheckConfigure, workflowStages, offerValidState };
    })
  );
  isCommentDialogOpened: boolean = false;
  readOnlyMode: any = null;
  offerResponse: any;
  PreviewMode = PreviewMode;
  public isRun = false;
  public isIAEnabled: boolean = false;
  public isCopyEnabled: boolean = false;
  public showMontage: boolean = false;
  public showComments: boolean = false;
  public isIAMontageEnabled: boolean = false;
  isIACopyProcessing = false;
  isIACopyReviewPending = false;
  isIACopyAwaitingSave = false;
  private previousOfferId: string | null = null;
  montageBuilderCheckConfigureStatus: boolean = false;
  versionsCount: number = 0;
  searchCount: number = 0;
  previewInfo = "";
  isSucceded = false;
  public showJunctionAi?: boolean = false;
  offerEditCanUndo = false;
  private jaiCreativeInfo: string = '';
  imageSrc: string | null = null;
  isPreviewLoading = true;
  private destroy$ = new Subject<void>();
  isMontageGenerationInProgress: boolean = false;
  selectedOfferProducts$ = this.montageBuilderService.selectedOfferProducts$;
  selectedOfferProducts: any = [];
  selectedOfferAssets = [];
  jaiMontageJSON: any;
  workflowStages: WorkflowStage[] = [];
  showChangesFromPreviousStep = false;
  modifiedPropertyNames: string[] = [];
  modifiedPropertyOldValues: Record<string, string> = {};
  awDetails: any = null;
  activeStage: any = null;
  activeStageIndex: number = -1;
  previousStage: any = null;
  constructor(
    public route: ActivatedRoute,
    public offerserv: OfferService<any, TOfferDomain>,
    private offerpromoService: OfferPromoService<TOfferPromo, TPromoDomain>,
    public router: Router,
    private eventService: EventService<TEvent>,
    private dialog: MatDialog,
    private montageBuilderService: MontageBuilderService,
    private authorizationService: AuthorizeControlService,
    public utilityService: UtilityService,
    private settingService: SettingsService,
    private offerProductService: OfferProductService<T>,
    private offerDetailService: OfferDetailService,
    private matSnackBar: MatSnackBar,
    private ewService: EventWorkflowService,
    private orgService: OrganizationService,
    private cdRef: ChangeDetectorRef,
    private assetsListService: AssetsListService
  ) { }

  ngOnInit(): void {
    // Reset undo UI state when entering offer screen.
    this.assetsListService.context = 'Offers';
    this.offerpromoService.setOfferEditCanUndo(false);
    this.resetPreviousStepChanges();
    this.offerpromoService.commentDialogBoxStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: boolean) => { this.isCommentDialogOpened = status });
    //this.checkIfReadOnlyMode();
    this.getWorkflowPermissions();
    this.offerserv.triggerNewVariant$
      .pipe(
        distinctUntilChanged(
          (x: any, y: any) => x === y
        ),
        takeUntil(this.destroy$))
      .subscribe((change) => {
        if (change && !this.offerserv.dialogueOpened) {
          this.openDialog();
          this.offerserv.addNewVariant = false;
        }
      });

    this.subscriptions.add(this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.Initialization();
    }));
    this.subscriptions.add(this.offerpromoService.jaiCreativeDetails$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.updatePreviewInfo(res);
      }
    }));
    this.subscriptions.add(this.offerpromoService.jaiCreativeApproved$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.approveHeadlineBodyCopy();
      }
    }));
    this.subscriptions.add(
      combineLatest([
        this.offerpromoService.iaCopyProcessing$,
        this.offerpromoService.iaCopyReviewPending$,
        this.offerpromoService.iaCopyAwaitingSave$,
      ]).pipe(takeUntil(this.destroy$)).subscribe(([processing, reviewPending, awaitingSave]) => {
        setTimeout(() => {
          this.isIACopyProcessing = processing;
          this.isIACopyReviewPending = reviewPending;
          this.isIACopyAwaitingSave = awaitingSave;
          if (!processing && this.offerResponse?.IACopyRequestId) {
            this.offerResponse = { ...this.offerResponse, IACopyRequestId: undefined };
          }
          this.cdRef.markForCheck();
        });
      })
    );
    this.subscriptions.add(
      this.offerpromoService.iaCopyError$.pipe(takeUntil(this.destroy$)).subscribe((error) => {
        if (!error) {
          return;
        }
        this.matSnackBar.open(error.message, 'OK', {
          ...DEFAULT_SNACKBAR_CONFIG,
          panelClass: ['snackbar-error'],
        });
      })
    );
    this.subscriptions.add(
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      ).subscribe(() => this.cdRef.markForCheck())
    );
    this.subscriptions.add(this.montageBuilderService.selectedOfferProducts$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.selectedOfferProducts = res;
      }
    }));
    this.subscriptions.add(this.montageBuilderService.selectedOfferAssets$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.selectedOfferAssets = res;
      }
    }));
    this.subscriptions.add(this.offerserv.previewHtml$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.updatePricingPreviewHtml(this.offerResponse, res);
      }
    }));

    this.subscriptions.add(
      this.offerpromoService.offerEditCanUndo$.pipe(takeUntil(this.destroy$)).subscribe((canUndo) => {
        // Avoid ExpressionChangedAfterItHasBeenCheckedError by updating async.
        setTimeout(() => {
          this.offerEditCanUndo = !!canUndo;
          this.cdRef.markForCheck();
        });
      })
    );
  }

  onRunMontage() {
    if (this.jaiMontageJSON?.Status === 'In Progress') {
      this.editMontage();
      return;
    }
    this.isMontageGenerationInProgress = true;
    this.setCurrentActiveItem('products');
    this.router.navigate(['../', this.offerId, 'products'], {
      relativeTo: this.route,
      queryParamsHandling: 'preserve'
    });
  }
  save() {
    this.offerserv.setSaveorCancel('1');
  }

  undo() {
    this.offerpromoService.requestOfferEditUndo();
  }

  cancel() {
    this.offerserv.setSaveorCancel('0');
  }

  deleteRecord(versionName: string) {
    this.offerpromoService.deleteRecord(versionName);
  }

  goToNewMontageEditor() {
    firstValueFrom(
      combineLatest([
        this.montageBuilderService.selectedOfferProducts$.pipe(take(1)),
        this.montageBuilderService.selectedOfferAssets$.pipe(take(1)),
      ])
    ).then(([products, assets]) => {
      const productIds = (products ?? [])
        .filter((product: any) => product?.Detail?.Id)
        .map((product: any) => product.FacingAsset.AssetId);
      const assetIds = (assets ?? [])
        .filter((asset: any) => asset?.Detail?.Id)
        .map((asset: any) => asset.Detail.Id);

      if (!assetIds.length && !productIds.length) {
        this.openNewMontageEditor();
        return;
      }

      const childAssetIds = [...assetIds, ...productIds];
      this.montageBuilderService.getByAssetsAndProducts(assetIds, productIds).pipe(take(1)).subscribe({
        next: (data: any) => {
          const historyItem = data?.value?.find((item: any) => !!item.OfferId && !!item.WebUrl);
          const currentMontageAssetId = this.offerResponse?.FacingAsset?.AssetId ?? '';

          if (
            !historyItem ||
            !shouldShowPreEditMontageHistory(historyItem, this.offerId, false, currentMontageAssetId)
          ) {
            this.openNewMontageEditor();
            return;
          }

          const preparedHistory = this.prepareMontageHistoryData(historyItem);
          this.montageBuilderService.montageShowVersionHistoryBehaviorSubject.next(preparedHistory);

          const dialogRef = this.dialog.open(MontageHistoryDialogComponent, {
            width: '40%',
            height: '40%',
            data: preparedHistory,
            disableClose: true,
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
            if (result === 'apply') {
              this.assetsListService.addMontageAssetByContext(this.offerId, historyItem.AssetId, childAssetIds).subscribe({
                next: () => {
                  this.montageBuilderService.selectedOfferAssetsBehaviorSubject.next([]);
                  this.montageBuilderService.selectedOfferProductsBehaviorSubject.next([]);
                  this.offerDetailService.reload();
                  this.assetsListService.reload();
                },
                error: (error) => {
                  this.matSnackBar.open(
                    error.error?.value?.join(', ') || 'Error adding associations.',
                    'OK',
                    DEFAULT_SNACKBAR_CONFIG
                  );
                },
              });
              return;
            }

            this.openNewMontageEditor();
          });
        },
        error: () => {
          this.openNewMontageEditor();
        },
      });
    });
  }

  private prepareMontageHistoryData(historyItem: any): any {
    const data = {
      ...historyItem,
      Asset: historyItem.Asset ? { ...historyItem.Asset } : historyItem.Asset,
    };

    try {
      if (data.WebUrl) {
        const url = new URL(data.WebUrl);
        url.searchParams.set('time', Date.now().toString());
        data.WebUrl = url.toString();
      }
      if (data.Asset?.WebUrl) {
        const assetUrl = new URL(data.Asset.WebUrl);
        assetUrl.searchParams.set('time', Date.now().toString());
        data.Asset.WebUrl = assetUrl.toString();
      }
    } catch {
      // ignore invalid urls
    }

    return data;
  }

  private openNewMontageEditor(): void {
    this.montageBuilderService.offerId = this.offerId;
    this.montageBuilderService.useNewMontageEditorBehaviorSubject.next(true);
    this.montageBuilderService.montageBuilderStatusBehaviorSubject.next(true);
  }

  goToMontageEditor() {
    this.isMontageGenerationInProgress = false;
    this.montageBuilderService.selectedOfferVariants = this.offerserv.selection.selected.length
      ? this.offerserv.selection.selected.filter((variant: any) => variant.Id !== this.offerId)
      : [];

    firstValueFrom(
      combineLatest([
        this.montageBuilderService.selectedOfferProducts$.pipe(take(1)),
        this.montageBuilderService.selectedOfferAssets$.pipe(take(1)),
      ])
    ).then(([products, assets]) => {
      const productIds = products
        .filter((product: any) => product?.Detail?.Id)
        .map((product: any) => product.Detail.Id);
      const assetIds = assets
        .filter((asset: any) => asset?.Detail?.Id)
        .map((asset: any) => asset.Detail.Id);

      if (!this.montageBuilderService.creativeId) {
        this.montageBuilderService.getJAICreativeMontage(this.offerId, assetIds, productIds).subscribe({
          next: (data: any) => {
            if (data?.Id) {
              this.montageBuilderService.creativeId = data.Id;
              if (data.MontageJson) {
                this.montageBuilderService.creativeMontageResponse = data.MontageJson;
              }
              this.openNewMontageEditor();
            }
          },
          error: (error: any) => {
            this.matSnackBar.open(
              error.error?.value?.join(', ') || 'Error fetching images from AI service.',
              'OK',
              DEFAULT_SNACKBAR_CONFIG
            );
          },
        });
        return;
      }

      this.openNewMontageEditor();
    });
  }

  async editMontage() {
    console.log('editMontage', this.offerResponse);
    let assetIds: string[] = [];
    let productIds: string[] = [];
    await firstValueFrom(this.montageBuilderService.selectedOfferAssets$).then(async (assets) => {
      if (assets.length > 0) {
        assets.forEach((asset: any) => {
          if (asset.Detail && asset.Detail.Id) {
            assetIds.push(asset.Detail.Id);
          }
        });
      }
      await firstValueFrom(this.montageBuilderService.selectedOfferProducts$).then((products) => {
        if (products.length > 0) {
          products.forEach((product: any) => {
            if (product.Detail && product.Detail.Id) {
              productIds.push(product.FacingAsset.AssetId);
            }
          });
        }
      });

      if (assetIds.length > 0 || productIds.length > 0) {
        const childAssetIds = [...assetIds, ...productIds];
        this.montageBuilderService
          .getByAssetsAndProducts(assetIds, productIds)
          .subscribe((data: any) => {
            if (data.value.length > 0) {
              const dialogRef = this.dialog.open(MontageHistoryPreviewComponent, {
                width: '40%',
                height: '40%',
                data: data.value[0],
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((res) => {
                if (res === 'apply') {
                  this.assetsListService.addMontageAssetByContext(this.offerId, data.value[0].AssetId, childAssetIds).subscribe({
                    next: () => {
                      this.montageBuilderService.selectedOfferAssetsBehaviorSubject.next([]);
                      this.montageBuilderService.selectedOfferProductsBehaviorSubject.next([]);
                      this.offerDetailService.reload();
                      this.assetsListService.reload();

                    },
                    error: (error) => {
                      this.matSnackBar.open(error.error.value.join(', ') || 'Error adding associations.', 'OK', DEFAULT_SNACKBAR_CONFIG);
                    }
                  });
                } else {
                  this.openNewMontageEditor();
                }
              });
            } else {
              this.montageBuilderService.selectedOfferVariants = this.offerserv.selection.selected.length ? this.offerserv.selection.selected.filter((variant: any) => variant.Id !== this.offerId) : [];
              this.montageBuilderService.creativeId = this.offerResponse.JAICreativeMontageId;
              this.openNewMontageEditor();
            }
          });
      } else {
        this.openNewMontageEditor();
      }

    });
  }

  private getWorkflowPermissions(): void {
    this.ewService.permissionForCurrentWorkflow$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (permissions: any) => this.handlePermissions(permissions),
        error: (error) => console.error('Error fetching permissions:', error),
      });
  }

  private handlePermissions(permissions: any): void {
    if (!permissions || permissions.length === 0) {
      return;
    }

    let inProgressWorkflowIndex = permissions.findIndex(
      (p: any) => p.Status === 'in_progress'
    );

    if (inProgressWorkflowIndex > -1) {
      let applicableWorkflowPermissions = permissions[inProgressWorkflowIndex];
      this.getWorkflowDetails(applicableWorkflowPermissions['WorkflowId']);
      this.processActiveStage(applicableWorkflowPermissions);
    }
  }

  private getWorkflowDetails(workflowId: string): void {
    this.ewService
      .getWorkflowDetailsForFeature(workflowId, this.orgService.silentAuthToken)
      .subscribe((details: any) => {
        this.awDetails = details;
      });
  }

  private processActiveStage(applicableWorkflowPermissions: any): void {
    if (!applicableWorkflowPermissions) return;

    const stages = applicableWorkflowPermissions.Stages;
    const activeStageIndex = stages.findIndex(
      (s: any) => s.Status === 'active' || s.Status?.trim() === '' || s.Status === 'not_started'
    );
    const previousStageIndex = stages.map((s: any) => s.Status).lastIndexOf('completed');
    if(previousStageIndex > -1) {
      this.previousStage = stages[previousStageIndex];
      console.log(`previousStage: `, this.previousStage);
    }
    if (activeStageIndex > -1) {
      let activeStage = stages[activeStageIndex];
      this.activeStage = activeStage;
      this.activeStageIndex = activeStageIndex;
      this.checkUserAccess(activeStage);
    }
    if (this.offerserv.isShowChangesFromPreviousStep && this.activeStageIndex >= 2) {
      this.onShowChangesFromPreviousStepChange(true);
    }
  }

  onShowChangesFromPreviousStepChange(checked: boolean): void {
    this.showChangesFromPreviousStep = checked;
    this.offerserv.setShowChangesFromPreviousStep(checked);

    if (!checked) {
      this.modifiedPropertyNames = [];
      this.modifiedPropertyOldValues = {};
      return;
    }

    const primarykey = this.offerId;
    const workflowTaskId = this.previousStage?.StageId;
    const type = this.labelType === LabelType.PROMO ? 'promo' : 'offer';

    if (!primarykey || primarykey === '0' || !workflowTaskId) {
      this.showChangesFromPreviousStep = false;
      this.offerserv.setShowChangesFromPreviousStep(false);
      this.matSnackBar.open(
        'Unable to load changes. Workflow stage is not available.',
        'OK',
        DEFAULT_SNACKBAR_CONFIG
      );
      return;
    }

    this.subscriptions.add(
      this.offerserv.getActivityLogsByWorkflowTaskId(primarykey, workflowTaskId, type).subscribe({
        next: (changes) => {
          const list = changes ?? [];
          this.modifiedPropertyNames = list
            .map((c) => getActivityLogPropertyName(c))
            .filter((name): name is string => !!name);
          const oldValues: Record<string, string> = {};
          list.forEach((c) => {
            const propertyName = getActivityLogPropertyName(c);
            const oldValue = getActivityLogOldValue(c);
            if (propertyName && oldValue) {
              oldValues[propertyName] = oldValue;
            }
          });
          this.modifiedPropertyOldValues = oldValues;
          this.offerserv.setModifiedPropertyNames(this.modifiedPropertyNames);
          this.offerserv.setModifiedPropertyOldValues(oldValues);
        },
        error: () => {
          this.showChangesFromPreviousStep = false;
          this.modifiedPropertyNames = [];
          this.modifiedPropertyOldValues = {};
          this.offerserv.setShowChangesFromPreviousStep(false);
          this.matSnackBar.open(
            'Failed to load changes from previous step',
            'OK',
            DEFAULT_SNACKBAR_CONFIG
          );
        },
      })
    );
  }

  isPropertyModified(...propertyKeys: string[]): boolean {
    return this.isPreviewFieldModified(...propertyKeys);
  }

  isPreviewFieldModified(...propertyKeys: string[]): boolean {
    return isPropertyModifiedInList(
      this.modifiedPropertyNames,
      this.showChangesFromPreviousStep,
      ...propertyKeys
    );
  }

  getPreviousStepOldValue(...propertyKeys: string[]): string | null {
    const text = lookupPreviousStepOldValue(
      this.modifiedPropertyOldValues,
      this.showChangesFromPreviousStep,
      ...propertyKeys
    );

    if (!text) {
      return null;
    }

    if (propertyKeys.some((key) => key.toLowerCase() === 'status')) {
      return this.formatPreviousStepStatusValue(text);
    }

    return text;
  }

  private formatPreviousStepStatusValue(value: string): string {
    const normalized = value.trim().toUpperCase();
    const statusLabels: Record<string, string> = {
      '0': 'PENDING',
      '1': 'PENDING',
      '2': 'APPROVED',
      '3': 'SUPPRESSED',
      PENDING: 'PENDING',
      APPROVED: 'APPROVED',
      SUPPRESSED: 'SUPPRESSED',
    };

    return statusLabels[normalized] ?? value;
  }

  private resetPreviousStepChanges(): void {
    this.modifiedPropertyNames = [];
    this.modifiedPropertyOldValues = {};
    this.offerserv.clearPreviousStepChanges();
    this.showChangesFromPreviousStep = this.offerserv.isShowChangesFromPreviousStep;
  }

  private checkUserAccess(activeStage: any): void {
    if (!activeStage || !this.orgService.loggedInUser?.email) return;

    const userFoundIndex = activeStage.Users.findIndex(
      (u: any) => u.Email?.toLowerCase()?.trim() === this.orgService.loggedInUser.email.toLowerCase().trim()
    );
    if (userFoundIndex > -1) {
      const user = activeStage.Users[userFoundIndex];
      this.readOnlyMode = user.Role === this.roles.reviewer;
    } else {
      this.readOnlyMode = true;
    }
  }

  Initialization() {
    this.resetPreviousStepChanges();
    this.offerId = this.route.snapshot.params['offerId'];
    if (this.offerId !== this.previousOfferId) {
      this.resetIACopyStateForOfferChange();
      this.previousOfferId = this.offerId;
    }
    this.offerpromoService.eventId = this.route.snapshot.params['eventId'];
    this.eventListPageDetails = JSON.parse(JSON.stringify(this.offerpromoService.getPageDetails()));
    this.offerTypeIdsByEventList = [];
    if (this.offerpromoService.getTypeIdsByEventInitialData()) {
      this.offerTypeIdsByEventList = this.offerpromoService.getTypeIdsByEventInitialData();
      this.currentTypeIndex = this.findIndexById(this.offerTypeIdsByEventList, this.offerId);
    } else {
      this.searchAllEventOfferTypeIdsByEvent();
    }

    this.montageBuilderService.montageBuilderStatusBehaviorSubject.next(false);
    this.montageBuilderService.useNewMontageEditorBehaviorSubject.next(false);
    this.montageBuilderService.montageGetEventTypeBehaviourSubject.next('');
    this.offerserv.newVersion = '';
    let apiCallInfo: any;
    if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'promos') {
      this.montageBuilderService.montageGetEventTypeBehaviourSubject.next('PROMO');
      this.labelType = LabelType.PROMO;
      apiCallInfo = `PromoDomains/${this.offerId}`;
    } else if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'offergroups') {
      this.montageBuilderService.montageGetEventTypeBehaviourSubject.next('OFFERGROUP');
      this.labelType = LabelType.OFFERGROUP;
      apiCallInfo = `OfferGroupDomains/${this.offerId}`;
    } else {
      this.labelType = LabelType.OFFER;
      this.montageBuilderService.montageGetEventTypeBehaviourSubject.next('OFFER');
      apiCallInfo = `OfferDomains/${this.offerId}`;
    }
    if (this.offerId && this.offerId != '0') {
      this.offerDetailService.offerorPromoId(apiCallInfo);
      this.getIntegrations();
      this.getActiveActions();
    }
    this.getVariants('');
  }



  searchAllEventOfferTypeIdsByEvent(): void {
    if (!this.eventListPageDetails) {
      console.error('Page details not available for initialization.');
      return;
    }

    const subscription = this.offerpromoService.searchAllEventOfferTypeIdsByEvent(this.eventListPageDetails).subscribe({
      next: (res: { '@odata.count': number; value: OfferVariantListModel[] }) => {
        const totalRecords = res['@odata.count'];
        const eventOfferTypeIds: OfferVariantListModel[] = res.value;

        if (!this.offerTypeIdsByEventList || this.offerTypeIdsByEventList.length !== totalRecords) {
          this.offerTypeIdsByEventList = Array(totalRecords).fill(null);
        }

        this.offerTypeIdsByEventList.splice(
          this.eventListPageDetails.pageIndex * this.eventListPageDetails.pageSize,
          eventOfferTypeIds.length,
          ...eventOfferTypeIds
        );

        const offerId = this.route.snapshot.params['offerId'];
        const index = this.findIndexById(this.offerTypeIdsByEventList, offerId);

        if (index > -1) {
          this.currentTypeIndex = index;

          if (this.shouldLoadNextPage(this.currentTypeIndex)) {
            this.loadPageIfNeeded(this.currentTypeIndex + 1, 'next');
          } else if (this.shouldLoadPreviousPage(this.currentTypeIndex)) {
            this.loadPageIfNeeded(this.currentTypeIndex - 1, 'previous');
          }
        } else if (this.eventListPageDetails.pageIndex < Math.ceil(totalRecords / this.eventListPageDetails.pageSize)) {
          this.eventListPageDetails.pageIndex++;
          this.searchAllEventOfferTypeIdsByEvent();
        } else {
          console.error('Reached the last page, but the record was not found.');
        }
      },
      error: (err) => {
        console.error('Error fetching event offer type IDs:', err);
      },
    });

    this.subscriptions.add(subscription);
  }

  // Check if the next page needs to be loaded
  private shouldLoadNextPage(currentIndex: number): boolean {
    return (
      this.offerTypeIdsByEventList[currentIndex + 1] == null &&
      currentIndex + 1 < this.offerTypeIdsByEventList.length
    );
  }

  // Check if the previous page needs to be loaded
  private shouldLoadPreviousPage(currentIndex: number): boolean {
    return (
      this.offerTypeIdsByEventList[currentIndex - 1] == null &&
      currentIndex - 1 >= 0
    );
  }

  // Navigate to the next offer
  nextOffer() {
    const offerId = this.route.snapshot.params['offerId'];
    let currentTypeIndex = this.findIndexById(this.offerTypeIdsByEventList, offerId);

    if (currentTypeIndex === -1 || currentTypeIndex >= this.offerTypeIdsByEventList.length - 1) {
      console.warn('Cannot navigate to the next offer: Invalid or last index.');
      return;
    }

    if (this.shouldLoadNextPage(currentTypeIndex)) {
      this.loadPageIfNeeded(currentTypeIndex + 1, 'next');
    }

    const nextType = this.offerTypeIdsByEventList[++currentTypeIndex];
    if (nextType) {
      this.navigateToNextItem(nextType?.Label, nextType?.VariantIds[0] || nextType.BaseId, currentTypeIndex);
    }
  }

  // Navigate to the previous offer
  previousOffer() {
    const offerId = this.route.snapshot.params['offerId'];
    let currentTypeIndex = this.findIndexById(this.offerTypeIdsByEventList, offerId);

    if (currentTypeIndex === -1 || currentTypeIndex <= 0) {
      console.warn('Cannot navigate to the previous offer: Invalid or first index.');
      return;
    }

    if (this.shouldLoadPreviousPage(currentTypeIndex)) {
      this.loadPageIfNeeded(currentTypeIndex - 1, 'previous');
    }

    const prevType = this.offerTypeIdsByEventList[--currentTypeIndex];
    if (prevType) {
      this.navigateToNextItem(prevType?.Label, prevType?.VariantIds[0] || prevType.BaseId, currentTypeIndex);
    }
  }

  private loadPageIfNeeded(index: number, direction: 'next' | 'previous') {
    const pageIndex = this.getPageIndex(index, this.eventListPageDetails.pageSize, direction === 'next');

    if (pageIndex < 0 || pageIndex * this.eventListPageDetails.pageSize >= this.offerTypeIdsByEventList.length) {
      console.warn('Page index out of bounds:', pageIndex);
      return;
    }

    this.eventListPageDetails.pageIndex = pageIndex;
    this.searchAllEventOfferTypeIdsByEvent();
  }

  findIndexById(list: (OfferVariantListModel | null)[], value: string): number {
    return list.findIndex(
      (item) => item?.BaseId === value || item?.VariantIds?.includes(value)
    );
  }

  getPageIndex(itemPosition: number, pageSize: number, nextPage: boolean = true): number {
    if (pageSize <= 0) {
      console.error('Invalid page size:', pageSize);
      return -1;
    }
    return Math.floor((itemPosition + (nextPage ? 1 : -1)) / pageSize);
  }

  navigateToNextItem(type: string, id: string, targetIndex: number): void {
    const typeRouteMap: { [key: string]: string } = {
      Offer: `../${id}/details`,
      Promo: `../${id}/promos/promodetails`,
      Offergroup: `../${id}/offergroups/offergrpdetails`,
    };

    if (!typeRouteMap[type]) {
      console.error('Invalid navigation type:', type);
      return;
    }

    const currentPath = this.route.snapshot.routeConfig?.path;
    const isInSubRoute = currentPath === 'promos' || currentPath === 'offergroups';

    let url = typeRouteMap[type];
    if (isInSubRoute) {
      url = '../' + url;
    }

    this.resetMontageBuilderProps();
    this.resetIACopyStateForOfferChange();
    const queryParams = this.route.snapshot.queryParams;
    this.router.navigate([url], { relativeTo: this.route, queryParams }).then((allowed) => {
      if (allowed) {
        this.currentTypeIndex = targetIndex;
      }
    });
  }

  checkIfReadOnlyMode() {
    this.readOnlyMode = this.offerpromoService.getOfferDetailsReadOnlyValue();
    this.offerpromoService.offerDetailsReadOnlyMode$.subscribe(
      (res) => (this.readOnlyMode = res)
    );
  }

  getVariants(variantName: string) {
    if (this.labelType == LabelType.OFFERGROUP) {
      this.offerserv.selection.clear();
      this.offerDetailService.offer$.pipe(
        filter((offer: any) => offer?.Detail?.Id === this.offerId),
        take(1)
      ).subscribe((offer: any) => {
        this.offerserv.selection.select(offer.Detail);
      });
      return;
    }

    if (this.offerId != '0') {
      if (this.labelType == LabelType.PROMO) {
        this.offerpromoService.offerId = this.route.snapshot.params['offerId'];
        this.offerpromoService.reloadPromoVersions();
        this.offerpromoService.getpromoChildVersions$.subscribe((res: any) => {
          this.updateVariantsValue(res, variantName);
        });
      } else {
        this.offerserv.offerId = this.route.snapshot.params['offerId'];
        this.offerserv.reloadOfferVersions();
        this.offerserv.getofferChildVersions$.subscribe((res: any) => {
          this.updateVariantsValue(res, variantName);
        });
      }
    }
  }

  updateVariantsValue(res: any, variantName: string) {
    if (res) {
      this.offerserv.selection.clear();
      this.variantsList = res.map((x: any) => x.Detail);
      const baseItem = this.variantsList.find(item => item.OfferVariantName === "Base");
      const baseId = baseItem ? baseItem.Id : this.variantsList[0].Id;
      this.baseVariantId = baseId;
      this.variantsCount = res.length;
      this.offerserv.variantsCount = res.length;
      if (variantName) {
        const versiontoAdd = { Id: new Date(), OfferVariantName: variantName };
        this.variantsList.push(versiontoAdd);
        this.newVersionName.patchValue(versiontoAdd);
      } else {
        const offer = this.variantsList.find((x: any) => x.Id === this.offerId);
        if (offer) {
          this.newVersionName.patchValue(offer);
          this.offerserv.selection.select(offer);
        }
      }
    }
  }

  isAllSelected() {
    const numSelected = this.offerserv.selection.selected.length;
    const numRows = this.variantsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.offerserv.selection.clear()
      : this.variantsList.forEach((row) =>
        this.offerserv.selection.select(row)
      );

    if (!this.isAllSelected()) {
      const variant = this.variantsList.find(
        (x) => x.Id === this.newVersionName.value.Id
      );
      this.offerserv.selection.select(variant);
    }
  }

  removeTag(tag: any): void {
    const rows = this.offerserv.selection.selected.filter(
      (x) => x.Id != tag.Id
    );
    this.offerserv.selection.clear();
    rows.forEach((row) => this.offerserv.selection.select(row));
  }

  openDialog() {
    const offer = this.offerserv.getCurrentRecord;
    const selectedVersions = this.offerserv.SelectedOfferVersionsList;
    if (offer) {
      const dialogRef = this.dialog.open(CloneOfferComponent, {
        width: '30%',
        height: '40%',
        data: { offerName: offer?.Detail?.Name, eventId: this.route.snapshot.params['eventId'], selectedVersionsList: selectedVersions },
      });
      this.offerserv.dialogueOpened = true;
      dialogRef.afterClosed().subscribe((res) => {
        // console.log('Response', res);
        this.offerserv.setSelectedOfferVersionsList = [];
        this.offerserv.dialogueOpened = false;
        if (res && res.formvalues && res.formvalues.Detail && res.formvalues.Detail.Name) {
          this.offerserv.newVersion = res.formvalues.Detail.Name;
          this.offerserv.selectedVersionsIds = res.selectedIds.map((x: any) => x.Id);
          this.versionNames.push(res.formvalues.Detail.Name);
          this.newVersionName.patchValue(res.formvalues.Detail.Name);
          this.disableNewVersion = true;
          this.goToOfferPromo(offer, res.formvalues.Detail.Name);
          this.offerDetailService.reload();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.resetPage();
    this.destroy$.next();
    this.destroy$.complete();
    this.montageBuilderService.selectedOfferProductsBehaviorSubject.next([]);
    this.montageBuilderService.selectedOfferAssetsBehaviorSubject.next([]);
    this.subscriptions.unsubscribe();
  }

  resetPage() {
    this.resetPreviousStepChanges();
    this.offerpromoService.jaiCreativeInfo(null);
    this.offerDetailService.reset();
    this.subscriptions.unsubscribe();
    this.offerserv.selection.clear();
    this.offerserv.currentRecord = {};
    this.offerserv.newVersion = '';
    this.offerserv.addNewVariant = null;
    this.offerserv.dialogueOpened = false;
    this.montageBuilderService.creativeId = '';
  }
  onSave() {
    this.offerserv.setSaveorCancel('1');
    this.disableNewVersion = false;
    this.offerserv.newVersion = '';
  }

  onCancel() {
    this.offerserv.setSaveorCancel('0');
    this.offerserv.newVersion = '';
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
    this.getVariants('');
  }

  tagSelected(event: MatAutocompleteSelectedEvent) { }

  resetMontageBuilderProps() {
    this.montageBuilderService.montageBuilderStatusBehaviorSubject.next(false);
    this.montageBuilderService.selectedOfferProductsBehaviorSubject.next([]);
    this.montageBuilderService.selectedOfferAssetsBehaviorSubject.next([]);
    this.montageBuilderService.montageBuilderResponseBehaviorSubject.next({});
  }

  private resetIACopyStateForOfferChange(): void {
    this.offerpromoService.clearSettledIACopyRequestIds();
    this.offerpromoService.resetIACopyState();
  }

  goToOfferPromo(OfferPromo: any, variantName?: string) {
    let urltoOpen = '';
    if (OfferPromo) {
      this.resetIACopyStateForOfferChange();
      if (OfferPromo.EventOfferType === 'OFFERGROUP') {
        this.labelType = LabelType.OFFERGROUP;
        urltoOpen = `../${OfferPromo.DomainId}/offergroups/offergrpdetails`;
      } else {
        this.labelType = OfferPromo.EventOfferType === 'PROMO' ? LabelType.PROMO : LabelType.OFFER;
        this.getVariants(variantName as string);
        urltoOpen = OfferPromo.EventOfferType === 'PROMO' ? `../${OfferPromo.DomainId}/promos/promodetails` : `../${OfferPromo.DomainId}/details`;
      }

      if (
        this.route.snapshot.routeConfig &&
        (this.route.snapshot.routeConfig.path === 'promos' || this.route.snapshot.routeConfig.path === 'offergroups')
      ) {
        urltoOpen = '../' + urltoOpen;
      }
      console.log(urltoOpen);
      this.router
        .navigate([urltoOpen], { relativeTo: this.route, queryParamsHandling: 'preserve' })
        .then((x) => { });
    }
  }

  getSelectedVersionDetail(event: any) {
    if (this.variantsList && this.variantsList.length > 0) {
      this.offerserv.newVersion = '';
      const variantName = this.variantsList.find(
        (x) => x.Id === event.value.Id
      );
      if (variantName && variantName.Id) {
        this.offerId = variantName.Id;
        let idtoOpen = {
          DomainId: variantName.Id,
          EventOfferType: this.labelType == LabelType.PROMO ? 'PROMO' : 'OFFER',
        };
        this.goToOfferPromo(idtoOpen);
      }
    }
    this.disableNewVersion = false;
  }

  setCurrentActiveItem(item: string) {
    this.activeNavItem = item;
  }

  openCommentsDialog($event: any, offer: any) {
    let channelName = '';
    switch (this.labelType) {
      case LabelType.OFFER:
        channelName = 'OFFER';
        break;
      case LabelType.PROMO:
        channelName = 'PROMO';
        break;
      case LabelType.OFFERGROUP:
        channelName = 'OFFERGROUP';
        break;
      default:
        break;
    }
    if (this.isCommentDialogOpened == false) {
      let commentElementStyle = document.getElementById(offer.DomainId) as HTMLElement;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = false;
      dialogConfig.data = {
        headline: offer.Detail.Headline,
        channel: offer.EventOfferType ? offer.EventOfferType : channelName,
        parentId: offer.Detail.Id,
        clientKey: offer.Detail.ClientKey,
        bodyCopy: offer.Detail.BodyCopy,
        showOfferCheckbox: true,
        workflowStage: this.workflowStages.length ? this.workflowStages[0] : null
      };

      let confirmDialog = this.dialog.open(CommentsComponent, dialogConfig);
      try {
        const instance = confirmDialog.componentInstance;
        instance.updateToOfferEmitter.subscribe(() => {
          this.updateTableStatus(Status.PENDING);
        });
      } catch (error) {
        console.error('Error accessing instance:', error);
      }

      confirmDialog.afterOpened().subscribe(() => {
        if (commentElementStyle) {
          commentElementStyle.style.color = "blue";
          this.offerpromoService.commentDialogBoxStatusBehaviorSubject.next(true);
        }
      });
      confirmDialog.afterClosed().subscribe((data) => {
        if (data > 0) {
          Object(offer).CommentsCount = data;
        }
        if (commentElementStyle) {
          commentElementStyle.style.color = "black";
          this.offerpromoService.commentDialogBoxStatusBehaviorSubject.next(false);
        }
      });
    }
  }

  updatePricingPreviewHtml(offer: any, updatedPreviewHtml: string = '') {
    if (updatedPreviewHtml && updatedPreviewHtml.length > 0) {
      this.pricingPreviewHtml = updatedPreviewHtml;
    } else if (offer && offer.OfferTypeId && offer.PricingPreviewHtml) {
      this.pricingPreviewHtml = offer.PricingPreviewHtml;
    } else {
      this.pricingPreviewHtml = '';
    }
  }

  updateImage(offer: any) {
    this.isPreviewLoading = true;
    const newUrl = this.utilityService.getOfferPreviewUrl(offer.FacingAsset, this.PreviewMode.Medium, true);

    if (this.imageSrc === newUrl) {
      this.imageSrc = null;
      setTimeout(() => {
        this.imageSrc = newUrl;
      });
    } else {
      this.imageSrc = newUrl;
    }
    setTimeout(() => {
      this.isPreviewLoading = false;
    });
  }

  onImageLoad(): void {
    // console.log('Image loaded:', this.imageSrc);
    this.isPreviewLoading = false;
  }

  onImageError(): void {
    this.isPreviewLoading = false;
    this.imageSrc = './assets/images/default-image.png';
  }

  updateTableStatus(status: Status) {
    let selectedRecordsDetails: any;
    const responseOffers =
      this.offerserv.selection.selected &&
        this.offerserv.selection.selected.length > 0
        ? this.offerserv.selection.selected
        : [this.offerResponse?.Detail];
    selectedRecordsDetails = responseOffers;
    this.updateRecordsStatus(selectedRecordsDetails, status);
  }

  updateRecordsStatus(selectedRecordsDetails: Array<any>, status: any) {
    if (selectedRecordsDetails && selectedRecordsDetails.length > 0) {
      const recordstoupdate = selectedRecordsDetails.map((x: any) => {
        return {
          Id: x.Detail ? x.Detail.Id : x.Id,
          Status: status,
          Label: x.Detail ? x.Detail.Label : x.Label
        };
      });

      this.offerpromoService.updateStatus(recordstoupdate).subscribe({
        next: () => {
          this.offerDetailService.reload();
        },
      });
    }
  }

  canEdit(): boolean {
    const hasAccess =
      this.authorizationService.checkAccess('edit||offermang') &&
      this.readOnlyMode != true;
    return hasAccess;
  }

  navigateChildOffers() {
    // const offerId = this.route.snapshot.paramMap.get('offerId');
    if (!this.baseVariantId) {
      console.log('BaseVariantId not found.');
      return;
    }

    switch (this.labelType) {
      case LabelType.OFFERGROUP:
        return;
      case LabelType.OFFER:
        this.router.navigate(['../', this.baseVariantId, 'childversions'], { relativeTo: this.route, queryParamsHandling: 'preserve' });
        break;
      case LabelType.PROMO:
        this.router.navigate(['../../', this.baseVariantId, 'promo', 'childversions'], { relativeTo: this.route, queryParamsHandling: 'preserve' });
        break;
      default:
        console.log(`Unhandled label type: ${this.labelType}`);
        break;
    }
  }

  approveHeadlineBodyCopy() {
    this.isRun = false;
    this.previewInfo = "";
  }


  onRun() {
    this.searchCount = 0;
    this.previewInfo = "";
    this.showReRun = false;
    this.offerpromoService.createJAICreative(this.offerId).subscribe((res: any) => {
      if (res) {
        if (!res.OfferId) {
          this.offerpromoService.jaiCreativeInfo({ ...res, isRun: false });
          this.isRun = false;
        } else {
          this.offerDetailService.reload();
        }
      }
    }, err => {
      let msg = 'Error: Invalid request';
      try {
        msg = (err.error && err.error.length > 0) ? err.error.map((x: string) => x).join(', ') : msg;
      } catch (e) {
        log.error('Error parsing error message:', e);
      }
      this.matSnackBar.open(
        'An error has occurred. Please review the following information for more details. ' + msg,
        'OK',
        DEFAULT_SNACKBAR_CONFIG
      );
    });
  }

  getJAICreative(id: string) {
    this.searchCount++;
    if (this.searchCount > 5) {
      this.searchCount = 0;
      this.showReRun = true;
      return;
    }
    this.offerpromoService.getJAICreative(id).subscribe((creativeDetails: any) => {
      if (creativeDetails && (creativeDetails.BodyCopy || creativeDetails.Headline || creativeDetails.HeadLine)) {
        this.offerpromoService.jaiCreativeInfo(creativeDetails);
        this.searchCount = 0;
        this.showReRun = false;
      } else {
        setTimeout(() => {
          if (this.searchCount <= 5) {
            this.getJAICreative(id);
          }
        }, 5000);
      }
    }, err => {
      let msg = (err.error && err.error.value.length > 0) ? err.error.value.map((x: string) => x).join(', ') : 'Error: Invalid request';
      this.matSnackBar.open(
        msg,
        'OK',
        DEFAULT_SNACKBAR_CONFIG
      );
      this.searchCount = 0;
      this.showReRun = false;
    });
  }

  getJAICreativeReRun() {
    if (this.offerResponse.JAICreativeId) {
      this.offerpromoService.getJAICreative(this.offerResponse.JAICreativeId).subscribe((creativeDetails: any) => {
        if (creativeDetails && (creativeDetails.BodyCopy || creativeDetails.Headline || creativeDetails.HeadLine)) {
          this.offerpromoService.jaiCreativeInfo(creativeDetails);
          this.showReRun = false;
        }
      });
    }
  }

  updatePreviewInfo(creativeDetails: any) {
    this.previewInfo =
      `<div class="pr-offer-preview"><h5 class="head-line">${creativeDetails.Headline || creativeDetails.HeadLine}</h5><div class="body-copy">${creativeDetails.BodyCopy}</div></div>`;
    this.isRun = true;
    this.showJunctionAi = false;
  }

  openPreviewDialog(asset: AssetDetails | null): void {
    if (!asset) return;

    const preview = this.resolveAssetUrls(asset);
    if (!preview.url) return;

    this.dialog.open(MediaPreviewComponent, {
      width: '600px',
      data: {
        name: asset.AssetName,
        url: asset.FileName,
        type: asset.FileType,
        assetUrl: preview.url,
        videoCaptionsUrl: preview.captions
      }
    });
  }

  private resolveAssetUrls(asset: AssetDetails): { url: string; captions: string } {
    const isZip = asset.FileType?.toLowerCase().includes('zip');

    if (!isZip) {
      return { url: asset.WebUrl ?? '', captions: '' };
    }

    // ZIP - VIDEO
    if (asset.ZipType?.includes('Video') && asset.ZipConfig) {
      try {
        const config = JSON.parse(asset.ZipConfig);

        return { url: config?.PrimaryFileUrl ?? '', captions: config?.CaptionsFileUrl ?? '' };
      } catch {
        console.log('Invalid ZipConfig JSON for asset:', asset.AssetName);
        return { url: '', captions: '' };
      }
    }
    // ZIP - NON VIDEO
    return { url: 'assets/images/mp4.png', captions: '' };
  }

  private hasIARequestId(id?: string | null): boolean {
    return !!id?.trim();
  }

  public isOnOfferDetailsTab(): boolean {
    if (this.labelType !== LabelType.OFFER) {
      return false;
    }
    const url = this.router.url;
    return /\/details(?:\?|$|\/)/.test(url)
      && !url.includes('promodetails')
      && !url.includes('offergrpdetails');
  }

  private resolveAIIconMode(offer: any): 'hidden' | 'processing' | 'initial' {
    if (!this.isIAEnabled || this.labelType !== LabelType.OFFER) {
      return 'hidden';
    }
    if (this.isIACopyReviewPending || this.isIACopyAwaitingSave) {
      return 'hidden';
    }
    if (this.isIACopyProcessing) {
      return this.isOnOfferDetailsTab() ? 'processing' : 'hidden';
    }
    if (this.hasIARequestId(offer?.IAMontageRequestId)) {
      return 'processing';
    }
    if (this.hasIARequestId(offer?.IACopyRequestId)) {
      return 'hidden';
    }
    return 'initial';
  }

  showIAProcessingIcon(offer: any): boolean {
    return this.resolveAIIconMode(offer) === 'processing';
  }

  showIAInitialIcon(offer: any): boolean {
    return this.resolveAIIconMode(offer) === 'initial';
  }

  private parseIACopyErrorMessage(err: any): string {
    let msg = 'Error: Invalid request';
    try {
      const body = err?.error;
      if (Array.isArray(body)) {
        msg = body.map((e: any) => e?.ErrorMessage ?? e).join(', ');
      } else if (body?.value?.length) {
        msg = body.value.join(', ');
      } else if (typeof body === 'string') {
        msg = body;
      }
    } catch (e) {
      log.error('Error parsing error message:', e);
    }
    return msg;
  }

  getActiveActions() {
    this.settingService.getActiveActions().subscribe((res) => {
      this.isIAEnabled = res.IAEnabled;
      this.isCopyEnabled = res.CopyEnabled;
      this.isIAMontageEnabled = res.MontageEnabled;
    });
  }

  getIntegrations() {
    this.settingService.getIntegrations().subscribe((res: any) => {
      this.settingService.addIntegrations(res);

      const montageIntegration = res.find((i: any) => i.ClientKey === 'montagebuilder');
      if (montageIntegration) {
        this.showMontage = montageIntegration.Status;
      }

      const conmmentsConfig = res.find((i: any) => i.ClientKey === 'retailercomments');
      if (conmmentsConfig) {
        this.showComments = conmmentsConfig.Status;
      }

    });
  }

  onCopyRun() {
    if (!this.offerId || this.offerId === '0') {
      return;
    }

    const sourceOfferId = this.offerId;
    this.offerpromoService.setIACopySourceOfferId(sourceOfferId);
    this.offerpromoService.setIACopyProcessing(true);
    this.offerpromoService.setIACopyError(null);
    this.offerpromoService.setIACopyAwaitingSave(false);

    this.settingService.generateCopy(sourceOfferId).subscribe({
      next: (outcome) => {
        if (this.offerId !== sourceOfferId) {
          return;
        }
        const requestId = outcome?.Request?.Id;
        if (!requestId) {
          this.offerpromoService.setIACopyProcessing(false);
          this.offerpromoService.setIACopyReviewPending(false);
          this.offerpromoService.setIACopyAwaitingSave(false);
          this.offerpromoService.setIACopyError({
            type: 'empty',
            message: 'No requests were generated.',
          });
          return;
        }
        if (this.offerResponse) {
          this.offerResponse = { ...this.offerResponse, IACopyRequestId: requestId };
        }
        this.offerDetailService.setIACopyRequestIdPatch(sourceOfferId, requestId);
        this.offerpromoService.unmarkIACopyRequestSettled(requestId);
        this.offerpromoService.setIACopyOutcome(outcome);
      },
      error: (err) => {
        if (this.offerId !== sourceOfferId) {
          return;
        }
        this.offerpromoService.setIACopyProcessing(false);
        this.offerpromoService.setIACopyReviewPending(false);
        this.offerpromoService.setIACopyAwaitingSave(false);
        this.offerpromoService.setIACopyError({
          type: 'generate_failed',
          message: this.parseIACopyErrorMessage(err),
        });
      },
    });
  }

  onMontageRun() {
    console.log('onMontageRun');
  }
}
